"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInit = void 0;

var _react = require("react");

var _api = require("../api");

var _actions = require("../context/actions");

var _useRequest = require("./useRequest");

var _useContextProvider2 = require("./useContextProvider");

var useCheck = function useCheck() {
  return (0, _useContextProvider2.useContextSelector)(function (ctx) {
    return {
      configured: ctx.state.userToken && ctx.state.guid,
      dispatch: ctx.dispatch
    };
  });
};

var useInit = function useInit() {
  var _useCheck = useCheck(),
      configured = _useCheck.configured,
      dispatch = _useCheck.dispatch;

  var state = (0, _useRequest.useRequest)();
  var request = state.request;

  var _useContextProvider = (0, _useContextProvider2.useContextProvider)(),
      config = _useContextProvider.config;

  (0, _react.useEffect)(function () {
    if (!configured) {
      void request((0, _api.init)());
    }
  }, [request, configured]);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.initConfig)(config.userToken, config.guid));
  }, [dispatch, config]);
  return state;
};

exports.useInit = useInit;